
import relatorioAtendimentoRepository from './relatorioAtendimentoRepository'

export default baseUrl => {
    return {
        relatorioAtendimento: relatorioAtendimentoRepository(baseUrl),
    }
}
